<template>
  <div class="c-video">
    <YoutubeEmbed :id="id" />
  </div>
</template>

<script>
import YoutubeEmbed from "./YoutubeEmbed.vue";

export default {
  components: { YoutubeEmbed },
  props: ["id"],
};
</script>
